import produce from "immer";
import { IStoreState } from "..";
import { LoadState } from "../../constants/enums";
import {
  CLEAR_SERVICE_INVOICE_STATE,
  CLEAR_SINGLE_SERVICE_INVOICE,
  FETCH_SERVICE_INVOICE_APPROVAL_LIST_FAILED,
  FETCH_SERVICE_INVOICE_APPROVAL_LIST_PROGRESS,
  FETCH_SERVICE_INVOICE_APPROVAL_LIST_SUCCESS,
  FETCH_SERVICE_INVOICE_LIST_FAILED,
  FETCH_SERVICE_INVOICE_LIST_PROGRESS,
  FETCH_SERVICE_INVOICE_LIST_SUCCESS,
  FETCH_SINGLE_SERVICE_INVOICE_FAILED,
  FETCH_SINGLE_SERVICE_INVOICE_PROGRESS,
  FETCH_SINGLE_SERVICE_INVOICE_SUCCESS,
} from "./service-invoice.actions";
import {
  defaultServiceInvoice,
  defaultServiceInvoiceState,
} from "./service-invoice.state";
import { IServiceInvoiceActions } from "./index";

export const serviceInvoiceReducer = (
  state: IStoreState["serviceInvoice"] = defaultServiceInvoiceState,
  action: IServiceInvoiceActions,
) => {
  switch (action.type) {
    case FETCH_SERVICE_INVOICE_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.service_invoice_list.loading = LoadState.InProgress;
        draftState.service_invoice_list.data = [];
        draftState.service_invoice_list.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_SERVICE_INVOICE_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.service_invoice_list.loading = LoadState.Loaded;
        draftState.service_invoice_list.data = list;
        draftState.service_invoice_list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_SERVICE_INVOICE_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.service_invoice_list.loading = LoadState.Failed;
        draftState.service_invoice_list.data = [];
        draftState.service_invoice_list.totalRecords = 0;
      });
      return newState;
    }

    case FETCH_SINGLE_SERVICE_INVOICE_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.single_service_invoice.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_SINGLE_SERVICE_INVOICE_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.single_service_invoice.loading = LoadState.Loaded;
        draftState.single_service_invoice.data = data;
      });
      return newState;
    }
    case FETCH_SINGLE_SERVICE_INVOICE_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.single_service_invoice.loading = LoadState.Failed;
        draftState.single_service_invoice.error = errorMessage;
      });
      return newState;
    }

    case CLEAR_SINGLE_SERVICE_INVOICE: {
      const newState = produce(state, (draftState) => {
        draftState.single_service_invoice.loading = LoadState.NotLoaded;
        draftState.single_service_invoice.data = defaultServiceInvoice;
        draftState.single_service_invoice.error = null;
      });
      return newState;
    }

    case CLEAR_SERVICE_INVOICE_STATE: {
      return defaultServiceInvoiceState;
    }

    // case FETCH_SERVICE_INVOICE_APPROVAL_LIST_PROGRESS: {
    //   const newState = produce(state, (draftState) => {
    //     draftState.service_invoice_approval_list.loading = LoadState.InProgress;
    //     draftState.service_invoice_approval_list.list = [];
    //     draftState.service_invoice_approval_list.totalRecords = 0;
    //   });
    //   return newState;
    // }
    // case FETCH_SERVICE_INVOICE_APPROVAL_LIST_SUCCESS: {
    //   const { data, totalRecords } = action.payload;
    //   const newState = produce(state, (draftState) => {
    //     draftState.service_invoice_approval_list.loading = LoadState.Loaded;
    //     draftState.service_invoice_approval_list.list = data;
    //     draftState.service_invoice_approval_list.totalRecords = totalRecords;
    //   });
    //   return newState;
    // }
    // case FETCH_SERVICE_INVOICE_APPROVAL_LIST_FAILED: {
    //   const newState = produce(state, (draftState) => {
    //     draftState.service_invoice_approval_list.loading = LoadState.Failed;
    //     draftState.service_invoice_approval_list.list = [];
    //     draftState.service_invoice_approval_list.totalRecords = 0;
    //   });
    //   return newState;
    // }

    default: {
      return state;
    }
  }
};
